var App = App || {};

App.CmpTestimonialsImage = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");

        if (carousel.length) {
            const slides = carousel.find(".splide__slide");
            let options = { pagination: false };

            if (slides.length < 2) {
                options = { ...options, perPage: 1 };
            }
            else {
                options = {
                    ...options,
                    perPage: 2,
                    breakpoints: {
                        1199: {
                            perPage: 1
                        }
                    }
                };
            }


            var splide = new Splide(carousel[0], options);

            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                    perPage: isOverflow ? splide.options.perPage : splide.length
                };
            });

            splide.mount({});

        }
    }

    return {
        Init: Init
    };

})(jQuery);